import { Helmet } from 'react-helmet-async'
import type { Product } from 'src/components/restructure/product/types/product'
import { buildProductGroupJsonLdArray } from 'src/utils/buildProductGroupJsonLd'

type ProductGroupJsonLdProps = {
  product: Product
  siteUrl: string
  slug: string
}

/**
 * PDP ProductGroup JSON-LD (SKU variants via hasVariant), SSR-safe via react-helmet-async.
 */
export function ProductGroupJsonLd({
  product,
  siteUrl,
  slug,
}: ProductGroupJsonLdProps) {
  const jsonLd = buildProductGroupJsonLdArray({ product, siteUrl, slug })

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(jsonLd, null, 2)}
      </script>
    </Helmet>
  )
}
